/**
 * The monogram: a lime square with a cut corner (a broadcast "tally" light shape) and a
 * condensed S. Pure SVG so it stays crisp in the 72px rail and in the browser tab.
 */
export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path d="M2 2h30l6 6v30H2z" fill="var(--accent)" />
      <text
        x="20"
        y="31"
        textAnchor="middle"
        fontFamily="var(--font-display)"
        fontWeight="900"
        fontSize="30"
        fill="var(--accent-contrast)"
      >
        S
      </text>
    </svg>
  );
}
